import React from 'react'
import Bredcom from '../../Bredcom/Main'
import First from '../Menfaq/First'

function Main() {
  return (
    <>
        <Bredcom title="Faq" subtitle="Home" subtitledown="Faq"/>
        <First/>
    </>
  )
}

export default Main